import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { userHasRequiredRole } from "./utils/authUtils";
import { loginRequest } from "./authConfig";

const ProtectedRoute = ({ component: Component, requiredRole, ...rest }) => {
  const { instance } = useMsal();
  const [authChecked, setAuthChecked] = useState(false);
  const [activeAccount, setActiveAccount] = useState(null);

  useEffect(() => {
    instance.handleRedirectPromise().then(() => {
      let account = instance.getActiveAccount();
      if (account) {
        if (userHasRequiredRole(account, requiredRole)) {
          setActiveAccount(account);
        } else {
          instance
            .logoutRedirect()
            .catch((error) => console.error("Logout error:", error));
        }
      } else {
        instance
          .loginRedirect(loginRequest)
          .catch((error) => console.error("Login error:", error));
      }
      setAuthChecked(true);
    });
  }, [instance, requiredRole]);

  if (!authChecked || !activeAccount) {
    return null;
  }

  return <Component {...rest} />;
};

export default ProtectedRoute;
